import { ReactNode } from 'react';

import clsx from 'clsx';

import Badge from '@/components/base/Badge';
import Tooltip from '@/components/base/Tooltip';

type NewKpiBadgeProps = {
    config: {
        new?: {
            dateAdded: string;
        };
        tooltip?: string | ReactNode;
    };
} & React.ComponentPropsWithoutRef<'span'>;

export const NewKpiBadge = ({ config, className, ...restProps }: NewKpiBadgeProps) => {
    function isInReleaseWindow(addedDate: string) {
        const releaseDate = new Date(addedDate);
        const today = new Date();
        const endDate = new Date(releaseDate.getTime() + 30 * 24 * 60 * 60 * 1000);
        return today <= endDate;
    }

    if (config.new?.dateAdded && isInReleaseWindow(config.new.dateAdded)) {
        return (
            <Tooltip content={config.tooltip} placement="top">
                <span className={clsx('absolute', className)} {...restProps}>
                    <Badge variant="new" />
                </span>
            </Tooltip>
        );
    }

    return null;
};
